/**
 * State used in rendering MenuPopover
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
